const useNinkaTvDetector = () => {
    const ninkaTvUrls = ['/blind-test/tv']
    const isNinkaTv = ninkaTvUrls.some((ninkaTvUrl) => window.location.pathname.match(ninkaTvUrl))

    return { isNinkaTv }
}

export default useNinkaTvDetector
